<script setup lang="ts">
// Composables
const { getZoneOptionList } = useExploreFilter();

// Stores
const { maxDepth } = storeToRefs(zoneStore());
const { loadZoneData } = useZoneService();
const { setMaxDepth } = zoneStore();

const updateMaxDepth = (value: string | number | undefined): void => {
  if (value) {
    setMaxDepth(Number(value));
    loadZoneData();
  }
};
</script>
<template>
  <div class="grid gap-4">
    <nrjx-input-select
      name="maxDepth"
      fit-to-select
      item-key="key"
      item-label="label"
      :leading-text="$t('explore.filters.depth')"
      :items="getZoneOptionList"
      :model-value="maxDepth"
      @update:model-value="updateMaxDepth"
    />
  </div>
</template>
